<template>
  <div>
    <div v-for="i in 6" :key="i" class="tw-inline-block tw-mr-4">
      <a
        href=""
        @click.prevent="$emit('update:modelValue', i)"
        :class="{
          'sf-btn-primary': modelValue == i,
          'sf-btn-secondary': modelValue != i,
        }"
      >
        Year {{ i }}
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    modelValue: {
      type: Number,
      required: true
    }
  }
})
</script>>